module.exports = __webpack_public_path__ + "static/media/tip_text_cat_cat_fr.1acfbdd1.svg";